import React from 'react';
import styled from 'styled-components';
import Avatar from '@material-ui/core/Avatar';

const DesignerAvatar = ({ img, alt }) => {
    const Wrapper = styled.div`
        flex-grow: 0;
        flex-shrink: 0;
        flex-base: ${props => props.theme.space[14]};
        width: ${props => props.theme.space[14]};
        margin-right: ${props => props.theme.space[8]};
        
        & img {
          max-width: ${props => props.theme.space[14]};
        }
        
        & .stolo-big-avatar {
          width: ${props => props.theme.space[14]};
          height: ${props => props.theme.space[14]};
          border-radius: 50%;
          font-size: 1.25rem;
        }
    `;

    const defaultImgUri = 'https://d1biw2rz2h5h5w.cloudfront.net/images/patterns/api/designers/notset.jpg';
    const imgUri = img || defaultImgUri;
    const altText = alt || 'Designer Avatar';

    return (
        <Wrapper >
            <Avatar
                alt={altText}
                src={imgUri}
                classes={{ root: 'stolo-big-avatar' }}
            />
        </Wrapper >
    );
};

export default DesignerAvatar;



// WEBPACK FOOTER //
// ./src/components/designer/DesignerAvatar.js